// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../../public/SiteIcons/credit-card.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../../../public/SiteIcons/calendar.svg");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../../../../public/SiteIcons/padlock.svg");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../../../../public/SiteIcons/location.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payment-errorMessage-a9k0q {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.Payment-space1-owPII {
	margin-bottom: 6px !important;
}
.Payment-space2-Sgko7 {
	margin-bottom: 12px !important;
}
.Payment-space3-flr17 {
	margin-bottom: 18px !important;
}
.Payment-space4-VxsGM {
	margin-bottom: 24px !important;
}
.Payment-space5-FrWVq {
	margin-bottom: 30px !important;
}
.Payment-space6-gdr5R {
	margin-bottom: 36px !important;
}
.Payment-space7-Jvb71 {
	margin-bottom: 42px !important;
}
.Payment-spaceTop8-SV3S8 {
	margin-bottom: 48px !important;
}
.Payment-spaceTop1-HZN0O {
	margin-top: 6px !important;
}
.Payment-spaceTop2-otjhl {
	margin-top: 12px !important;
}
.Payment-spaceTop3-dmDNJ {
	margin-top: 18px !important;
}
.Payment-spaceTop4-NzjUV {
	margin-top: 24px !important;
}
.Payment-spaceTop5-SNydT {
	margin-top: 30px !important;
}
.Payment-spaceTop6-Xb20G {
	margin-top: 36px !important;
}
.Payment-spaceTop7-BA9Cg {
	margin-top: 42px !important;
}
.Payment-spaceTop8-SV3S8 {
	margin-top: 48px !important;
}
.Payment-noMargin-PoQFy {
	margin: 0px !important;
}
.Payment-padding1-g5knV {
	padding-bottom: 6px !important;
}
.Payment-padding2-RIkR3 {
	padding-bottom: 12px !important;
}
.Payment-padding3-AsmKO {
	padding-bottom: 18px !important;
}
.Payment-padding4-GogI9 {
	padding-bottom: 24px !important;
}
.Payment-padding5-PJlZz {
	padding-bottom: 30px !important;
}
.Payment-padding6-MSg70 {
	padding-bottom: 36px !important;
}
.Payment-padding7-j2Ir3 {
	padding-bottom: 42px !important;
}
.Payment-paddingTop1-Sof1z {
	padding-top: 6px !important;
}
.Payment-paddingTop2-xZG4n {
	padding-top: 12px !important;
}
.Payment-paddingTop3-vq92u {
	padding-top: 18px !important;
}
.Payment-paddingTop4-PRqXc {
	padding-top: 24px !important;
}
.Payment-paddingTop5-HNNKn {
	padding-top: 30px !important;
}
.Payment-paddingTop6-McxMl {
	padding-top: 36px !important;
}
.Payment-paddingTop7-qHheT {
	padding-top: 42px !important;
}
.Payment-noPadding-vkxVH {
	padding: 0px !important;
}
.Payment-textBold-QvDeZ {
	font-weight: 500 !important;
}
.Payment-textBolder-EEBBs {
	font-weight: 700 !important;
}
.Payment-textNormal-hx7W3 {
	font-weight: normal !important;
}
.Payment-spaceBottom20-UVXF2 {
	margin-bottom: 20px;
}
.Payment-spaceBottom10-RzJeM {
	margin-bottom: 10px;
}
.Payment-marginNone-dkVQN {
	margin: 0;
}
.Payment-spaceBottom15-rOzM9 {
	margin-bottom: 15px;
}
.Payment-marginTopNone-kCRk_ {
	margin-top: 0;
}
.Payment-spaceTop11-Ag1qo {
	margin-top: 11px;
}
.Payment-spaceTop21-wllkI {
	margin-top: 21px;
}
.Payment-spaceTop20-__3FB {
	margin-top: 20px;
}
.Payment-spaceTop10-snOaU {
	margin-top: 10px;
}
/*New Design Text Colors */
.Payment-textDarkBlue-k9oRc {
	color: rgb(20, 39, 94) !important;
}
.Payment-textLightBlue-DDoiv {
	color: rgb(57, 87, 106) !important;
}
.Payment-textLightSandleGreen-alkcl {
	color: rgb(76, 86, 41) !important;
}
.Payment-textLightBrown-u5mto {
	color: rgb(115, 79, 33) !important;
}
.Payment-textMediumMaroon-d7mqQ {
	color: rgb(87, 37, 51) !important;
}
.Payment-textBrown-Zpc75 {
	color: rgb(160, 47, 24) !important;
}
.Payment-textMaroon-S_zQF {
	color: rgb(155, 49, 67) !important;
}
.Payment-textDarkBrown-ErcVZ {
	color: rgb(83, 18, 16) !important;
}
.Payment-textMediumBrown-x5OlM {
	color: rgb(142, 28, 10) !important;
}
.Payment-textSkyBlue-AOrIy {
	color: rgb(37, 117, 141) !important;
}
.Payment-textGray-QthXf {
	color: rgb(77, 65, 51) !important;
}
.Payment-bookItPanel-VtfJ0 {
	font-size: 16px;
	padding: 5px;
}
.Payment-textLeft-UNohi {
	text-align: left;
}
.Payment-textRight-aPJ4d {
	text-align: right;
}
.Payment-textGray-QthXf {
	font-size: 14px;
}
.Payment-checkInDate-hJhA2 {
	font-size: 14px;
}
.Payment-pullLeft-Ei4PU {
	float: left;
}
.Payment-pullRight-f1rbc {
	float: right;
}
.Payment-h3-UvgXU {
	font-size: 20px;
	margin: 0;
}
.Payment-bookItDetails-DPUBO {
	font-size: 16px;
}
.Payment-textArea-ckvJu {
	height: 110px !important;
	border-radius: 6px;
	margin-top: 20px;
	border-color: var(--primary-border);
}
.Payment-houseRules-cw7Vy {
	padding-bottom: 20px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}
.Payment-houseRules-cw7Vy:last-child {
	padding-bottom: 0;
}
.Payment-textCenter-Ahj_F {
	text-align: center;
}
.Payment-paymentHeader-NMqkf {
	padding: 5px;
	font-size: 16px;
}
.Payment-textLight-pVMcG {
	color: var(--secondary-foreground);
	margin-top: 15px;
	font-size: 12px;
	display: block;
}
.Payment-countryName-x4IYl {
	margin: 0px 0px 8px;
}
.Payment-selectContainer-K27Hk {
	font-size: 19px;
	line-height: 24px;
	position: relative;
	display: block;
	width: 100%;
	max-width: 320px;
}
.Payment-formControlSelect-V6hDt {
	padding: 8px 10px !important;
	width: 100%;
	display: inline-block;
	overflow: hidden;
	-webkit-appearance: none;
	   -moz-appearance: none;
	        appearance: none;
	max-width: 250px;
}
.Payment-colCenter-g5vCG {
	border: 1px solid var(--primary-border);
	border-radius: 15px;
}
.Payment-backgroundCover-AVpTS {
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	background-color: var(--secondary-gray-bg);
	border-radius: 6px;
}
.Payment-bannerImage-ZbrHv {
	padding-top: 60%;
	position: relative;
}
.Payment-profileAvatarSection-xPkLK {
	position: relative;
	text-align: center;
	margin: 0 auto;
}
.Payment-profileAvatarLink-nIYcT {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	border-radius: 50%;
	background-color: var(--secondary-gray-bg);
	border: 2px solid var(--primary-border);
}
.Payment-profileAvatar-pjsje {
	height: 60px;
	width: 60px;
}
.Payment-panelHeader-Ly5AA {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	border-bottom-left-radius: 4px !important;
	border-bottom-right-radius: 4px !important;
}
.Payment-textMuted-xm7br {
	color: var(--secondary-foreground);
	font-size: 16px;
}
.Payment-textLarge-biOpI {
	font-size: 24px;
	line-height: 30px;
}
.Payment-listStyle-L3kfa {
	margin: 3px 0;
	padding-left: 0;
	list-style: none;
}
.Payment-noBorder-Gxanp {
	border: 0px none !important;
}
.Payment-tableText-H_MPh {
	font-weight: normal;
}
.Payment-totalText-edjy6 {
	border: 0;
	padding: 0;
	width: 100%;
	background: transparent;
	text-align: start;
	cursor: default;
	pointer-events: none;
	font-size: 24px;
	line-height: 30px;
}
a {
	color: var(--primary-link-foreground);
	text-decoration: none;
}
a:hover {
	color: var(--primary-link-foreground);
	cursor: pointer;
}
.Payment-horizondalLine-K82vJ {
	margin: 15px 0;
	border-top: 1px solid var(--primary-border);
}
.Payment-displayInline-eiquD {
	display: inline-block;
}
.Payment-avatarWidth-gQIgL {
	width: 43%;
	text-align: center;
	padding-right: 15px;
}
.Payment-contentWidth-wcyAg {
	width: 57%
}
.Payment-positionSticky-K2qPT {
	position: sticky !important;
	top: 20px;
}
.Payment-secondSection-SNdEs {
	padding: 20px;
	border-bottom: 1px solid var(--primary-border);
	margin-bottom: 20px;
}
.Payment-propertyText-it5bD {
	font-size: 18px;
	line-height: 24px;
}
.Payment-listItem-SR0fd {
	font-size: 14px;
	color: var(--secondary-foreground);
}
.Payment-postionRelative-ukkUB {
	position: relative;
}
.Payment-arrrowIcon-AfOki {
	max-width: 24px;
}
.Payment-policyColor-cQXR7 {
	color: var(--primary-link-foreground) !important;
	text-decoration: none !important;
}
.Payment-vtrMiddle-ELBTO {
	vertical-align: middle;
}
.Payment-textEllipsis-TAL2d {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.Payment-avatarImage-tzIeo {
	width: 100%;
	max-width: 63px;
	border-radius: 50%;
	height: 63px;
}
.Payment-displayTable-OjhvB {
	display: table;
	width: 100%;
}
.Payment-displayTableRow-Bi5zI {
	display: table-row;
	width: 100%;
}
.Payment-displayTableCell-Qlgq5 {
	display: table-cell;
}
.Payment-avatarSection-RvetV {
	width: 12%;
	padding-right: 12px;
}
.Payment-messageSection-qne5R {
	font-size: 18px;
}
.Payment-vtrTop-uPtZQ {
	vertical-align: top;
}
.Payment-itemWidth-HCzgr {
	padding-left: 9px;
}
.Payment-aboutNoMargin-snra1 {
	margin-top: 0;
	padding-top: 0
}
.Payment-aboutPaymentDesc-AzRff {
	margin: 15px 0 25px;
	font-size: 16px;
}
.Payment-paymentPadding-IzpKe {
	padding-left: 8px;
}
.Payment-cancelBtn-wDQ57 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	margin-left: 25px;
}
.Payment-cancelLinkText-OVnSx {
	margin-left: 12px;
	padding: 8px 27px;
	color: var(--primary-link-foreground);
	font-size: 14px;
	cursor: pointer;
}
.Payment-cancelLinkText-OVnSx:hover,
.Payment-cancelLinkText-OVnSx:focus,
.Payment-cancelLinkText-OVnSx:active,
.Payment-cancelLinkText-OVnSx:active:hover,
.Payment-cancelLinkText-OVnSx:active:focus {
	color: var(--primary-link-foreground);
}
.Payment-specialPriceText-MWQ1B {
	display: inline-block;
	vertical-align: middle;
}
.Payment-faqImage-DqGn9 {
	width: 100%;
	max-width: 19px;
	vertical-align: middle;
	margin-right: 5px;
}
.Payment-fullWidth-uEg2R {
	width: 100%;
}
.Payment-pullRight-f1rbc {
	float: right !important;
}
.Payment-cardInput-t3E6C {
	display: block;
	width: 100%;
	padding: 6px 12px;
	font-size: 14px;
	line-height: 1.42857143;
	background-color: var(--primary-input-bg);
	background-image: none;
	border-radius: 4px;
	height: 40px;
	border: 1px solid var(--primary-border);
	margin-bottom: 15px;
	font-weight: 400;
}
.Payment-cardInput-t3E6C:focus {
	border-color: var(--primary-border) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
}
.Payment-cardNumber-t9H_B {
	padding: 10px 0;
	border: 0;
	border-bottom: 1px solid var(--primary-border);
	border-radius: 0;
}
.Payment-cardNumberSection-giKMr {
	position: relative;
}
.Payment-cardNumberSectionOne-kHjfG {
	text-align: left;
}
.Payment-cardNumberSectionOne-kHjfG::after {
	content: '';
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	position: absolute;
	top: 8px;
	bottom: 0px;
	background-repeat: no-repeat;
	width: 100%;
	background-position: 100%;
	max-width: 25px;
	right: 0;
	z-index: 0;
}
.Payment-cardNumberSectionTwo-gQtMv::after {
	content: '';
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	position: absolute;
	top: 0px;
	bottom: 0px;
	background-repeat: no-repeat;
	width: 100%;
	background-position: 100%;
	max-width: 25px;
	right: 0;
	z-index: 0;
}
.Payment-cardNumberSectionThree-sxTXs::after {
	content: '';
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	position: absolute;
	top: 0px;
	bottom: 0px;
	background-repeat: no-repeat;
	width: 100%;
	background-position: 100%;
	max-width: 25px;
	right: 0;
	z-index: 0;
}
.Payment-cardNumberSectionFour-nI1_V {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
	background-repeat: no-repeat;
	background-position: 100%;
}
.Payment-noBoxShadow-yYJ5w {
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	outline: none !important;
}
.Payment-labelText-UfIMF {
	margin-bottom: 0 !important;
	font-size: 14px !important;
	font-weight: 600;
}
.Payment-stripeImg-eLAcU {
	max-width: 170px;
}
.Payment-cardSection-cCIm5 {
	padding: 25px !important;
	margin: 20px 15px 0;
	border-radius: 6px;
	border: 1px solid var(--primary-border);
}
.Payment-titleText-SjjCe {
	font-size: 26px;
	font-weight: 600;
	margin-bottom: 30px;
}
.Payment-dateTitle-unvZW {
	font-size: 18px;
	margin-bottom: 7px;
}
.Payment-showDate-Akglr {
	color: var(--secondary-foreground);
}
.Payment-flex-gooqR {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}
.Payment-disabledLink-OOWrp {
	pointer-events: none;
	cursor: default;
	opacity: 0.6;
}
.Payment-editCss-wSUaE {
	color: var(--primary-link-foreground) !important;
	font-size: 16px;
	text-decoration: underline;
}
.Payment-editIcon-kHIlQ {
	position: relative;
	top: -2px;
	display: inline-block;
	margin-left: 3px;
}
.Payment-marginTop-kfjpy {
	margin-top: 25px;
}
.Payment-commonBorder-_kIjn {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}
.Payment-grid-Jjzna {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	color: var(--secondary-foreground);
	padding: 0 20px 10px 20px;
	font-size: 16px;
	gap: 10px;
}
.Payment-totalValue-AWHev {
	border-top: 1px solid var(--primary-border);
	padding: 20px;
	color: var(--primary-foreground);
	font-size: 18px;
	margin-top: 10px;
	font-weight: 600;
}
.Payment-policyCss-w34fX {
	text-align: center;
	margin: 30px 0;
}
.Payment-noPaddingLeft-t11fG {
	padding-left: 0;
}
.Payment-noPaddingRight-vI2Nj {
	padding-right: 0;
}
.Payment-noPadding-vkxVH {
	padding: 0;
}
.Payment-payPalTop-GvWni {
	margin-top: 20px;
}
.Payment-footerBtns-O9PWA {
	border-top: 1px solid var(--primary-border);
	margin: 25px 0 40px;
	padding-top: 25px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
}
.Payment-pricingTitle-n6S4e {
	font-size: 18px;
	margin-bottom: 15px;
	padding-left: 20px;
}
.Payment-reviewFlex-jsF0a {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}
.Payment-dotsCss-gIQEY {
	margin: 0 8px;
}
.Payment-starCss-RDMmw {
	position: relative;
	top: 4px;
	margin-right: 2px;
}
.Payment-radioTextSection-jZ2MU {
	font-weight: 400;
}
.Payment-hostFlex-vgDv2 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-column-gap: 15px;
	   -moz-column-gap: 15px;
	        column-gap: 15px;
}
.Payment-bold-uHhdv {
	font-weight: 600;
}
.Payment-loaderFlex-_T8Ps {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-column-gap: 3px;
	   -moz-column-gap: 3px;
	        column-gap: 3px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}
.Payment-discountText-_Sava {
	color: var(--discountAndSpecial-color);
}
.Payment-cancelBtnLineHeight-rkiPX {
	line-height: 23px;
}
.Payment-houseRulesTick-NG4dD {
	color: var(--secondary-bg);
}
@media screen and (max-width: 1200px) {
	.Payment-colCenter-g5vCG {
		margin: 0 15px;
	}
}
@media (max-width: 1200px) and (min-width: 992px) {
	.Payment-positionSticky-K2qPT {
		top: 100px;
	}
}
@media (max-width: 1199px) and (min-width: 992px) {
	.Payment-avatarWidth-gQIgL {
		width: 40%;
	}

	.Payment-contentWidth-wcyAg {
		width: 60%;
	}

	.Payment-propertyText-it5bD {
		line-height: 24px;
	}
}
@media screen and (max-width: 1199px) {
	.Payment-listItem-SR0fd {
		font-size: 14px;
	}

	.Payment-bookItPanel-VtfJ0 {
		padding: 50px 15px 0;
	}
}
@media (max-width: 991px) and (min-width: 640px) {
	.Payment-avatarWidth-gQIgL {
		width: 40%;
		text-align: center;
		padding-right: 6px;
	}

	.Payment-contentWidth-wcyAg {
		width: 60%;
	}

	.Payment-propertyText-it5bD {
		line-height: 24px;
	}

}
@media screen and (max-width: 767px) {
	.Payment-flexwrap-MOoqz {
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
	}

	.Payment-paddingRight15-QYVIA {
		padding-right: 15px !important;
	}

	.Payment-paddingLeft15-DolWh {
		padding-left: 15px !important;
	}

	.Payment-expireSection-MFctV {
		margin-bottom: 12px;
		padding-top: 0px !important;
	}

	.Payment-cardSection-cCIm5 {
		margin: 20px 0px 0px;
	}

	.Payment-responsivecardSection-_ioDt {
		padding: 0 15px !important;
	}

	.Payment-noMobileLeftPadding-Hccck {
		padding-left: 0;
	}

	.Payment-noMobileRightPadding-AvTt2 {
		padding-right: 0;
	}
}
@media screen and (max-width: 640px) {
	.Payment-smPadding-Lbx2V {
		padding: 0;
	}
}
@media screen and (max-width: 767px) {
	.Payment-avatarWidth-gQIgL {
		width: 40%;
	}

	.Payment-contentWidth-wcyAg {
		width: 60%;
	}

	.Payment-propertyText-it5bD {
		font-size: 16px;
		line-height: 18px;
	}

	.Payment-bannerImage-ZbrHv {
		padding-top: 70%;
	}

	.Payment-profileAvatar-pjsje {
		width: 50px;
		height: 50px;
	}

	.Payment-avatarSection-RvetV {
		width: 24%;
		padding-right: 6px;
	}

	.Payment-vtrTopSm-TRhXo {
		vertical-align: top;
	}
}
@media screen and (max-width:991px) {
	.Payment-positionSticky-K2qPT {
		position: inherit !important;
		top: auto;
	}
}
/* Sticky Footer Styles */
.Payment-stickyFooter-XEN08 {
	position: fixed !important;
	bottom: 0px !important;
	left: 0px !important;
	right: 0px !important;
	z-index: 4;
	display: none;
}
.Payment-stickyFooterContainer-EqApM {
	background-color: var(--background-primary) !important;
	padding: 16px 24px !important;
	z-index: 5 !important;
	border-top: 1px solid var(--primary-border) !important;
	-webkit-box-shadow: 0px 0px 4px 1px var(--primary-box-shadow);
	        box-shadow: 0px 0px 4px 1px var(--primary-box-shadow);
}
.Payment-stickyFooterContent-iiCPk {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	max-width: 1200px;
	margin: 0 auto;
}
.Payment-stickyFooterButton-AkfIs {
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}
@media screen and (max-width: 767px) {
	.Payment-stickyFooter-XEN08 {
		display: block;
	}

	.Payment-bookItPanel-VtfJ0 {
		/* padding-bottom: 100px; Prevent content from being hidden behind footer */
		padding-bottom: 15px;
	}

	.Payment-footerBtns-O9PWA {
		display: none; /* Hide original footer buttons on mobile */
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/Booking/Payment/Payment.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA;CACC,eAAe;CACf,YAAY;AACb;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,YAAY;AACb;AAEA;CACC,eAAe;CACf,SAAS;AACV;AAEA;CACC,eAAe;AAChB;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,gBAAgB;CAChB,mCAAmC;AACpC;AAGA;CACC,oBAAoB;CACpB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;AAEA;CACC,kCAAkC;CAClC,gBAAgB;CAChB,eAAe;CACf,cAAc;AACf;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,gBAAgB;AACjB;AAEA;CACC,4BAA4B;CAC5B,WAAW;CACX,qBAAqB;CACrB,gBAAgB;CAChB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,gBAAgB;AACjB;AAEA;CACC,uCAAuC;CACvC,mBAAmB;AACpB;AAEA;CACC,sBAAsB;CACtB,kCAAkC;CAClC,4BAA4B;CAC5B,0CAA0C;CAC1C,kBAAkB;AACnB;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,uCAAuC;AACxC;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,yCAAyC;CACzC,0CAA0C;AAC3C;AAEA;CACC,kCAAkC;CAClC,eAAe;AAChB;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;AAEA;CACC,aAAa;CACb,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;CACT,UAAU;CACV,WAAW;CACX,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;CACf,oBAAoB;CACpB,eAAe;CACf,iBAAiB;AAClB;AAEA;CACC,qCAAqC;CACrC,qBAAqB;AACtB;AAEA;CACC,qCAAqC;CACrC,eAAe;AAChB;AAEA;CACC,cAAc;CACd,2CAA2C;AAC5C;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,mBAAmB;AACpB;AAEA;CACC;AACD;AAEA;CACC,2BAA2B;CAC3B,SAAS;AACV;AAEA;CACC,aAAa;CACb,8CAA8C;CAC9C,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,gDAAgD;CAChD,gCAAgC;AACjC;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;AAEA;CACC,cAAc;CACd,WAAW;AACZ;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,UAAU;CACV,mBAAmB;AACpB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,aAAa;CACb;AACD;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,iBAAiB;AAClB;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,qCAAqC;CACrC,eAAe;CACf,eAAe;AAChB;AAEA;;;;;CAKC,qCAAqC;AACtC;AAEA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,iBAAiB;AAClB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,cAAc;CACd,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,uBAAuB;CACvB,yCAAyC;CACzC,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;CACZ,uCAAuC;CACvC,mBAAmB;CACnB,gBAAgB;AACjB;AAEA;CACC,8CAA8C;CAC9C,mCAA2B;SAA3B,2BAA2B;AAC5B;AAEA;CACC,eAAe;CACf,SAAS;CACT,8CAA8C;CAC9C,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,WAAW;CACX,yDAAqE;CACrE,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,4BAA4B;CAC5B,WAAW;CACX,yBAAyB;CACzB,eAAe;CACf,QAAQ;CACR,UAAU;AACX;AAEA;CACC,WAAW;CACX,yDAAkE;CAClE,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,4BAA4B;CAC5B,WAAW;CACX,yBAAyB;CACzB,eAAe;CACf,QAAQ;CACR,UAAU;AACX;AAEA;CACC,WAAW;CACX,yDAAiE;CACjE,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,4BAA4B;CAC5B,WAAW;CACX,yBAAyB;CACzB,eAAe;CACf,QAAQ;CACR,UAAU;AACX;AAEA;CACC,yDAAkE;CAClE,4BAA4B;CAC5B,yBAAyB;AAC1B;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,wBAAwB;AACzB;AAEA;CACC,2BAA2B;CAC3B,0BAA0B;CAC1B,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,uCAAuC;AACxC;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,YAAY;AACb;AAEA;CACC,gDAAgD;CAChD,eAAe;CACf,0BAA0B;AAC3B;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,qBAAqB;CACrB,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,kCAAkC;CAClC,yBAAyB;CACzB,eAAe;CACf,SAAS;AACV;AAEA;CACC,2CAA2C;CAC3C,aAAa;CACb,gCAAgC;CAChC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,eAAe;AAChB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,UAAU;AACX;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;CACnB,iBAAiB;CACjB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;AAC1B;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,kBAAkB;AACnB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uBAAe;IAAf,oBAAe;SAAf,eAAe;CACf,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;AAEA;CACC,sCAAsC;AACvC;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC;EACC,cAAc;CACf;AACD;AAEA;CACC;EACC,UAAU;CACX;AACD;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,iBAAiB;CAClB;AACD;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,oBAAoB;CACrB;AACD;AAEA;CACC;EACC,UAAU;EACV,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,iBAAiB;CAClB;;AAED;AAEA;CACC;EACC,mBAAe;MAAf,eAAe;CAChB;;CAEA;EACC,8BAA8B;CAC/B;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,mBAAmB;EACnB,2BAA2B;CAC5B;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;AACD;AAEA;CACC;EACC,UAAU;CACX;AACD;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,UAAU;EACV,kBAAkB;CACnB;;CAEA;EACC,mBAAmB;CACpB;AACD;AAEA;CACC;EACC,4BAA4B;EAC5B,SAAS;CACV;AACD;AAEA,yBAAyB;AACzB;CACC,0BAA0B;CAC1B,sBAAsB;CACtB,oBAAoB;CACpB,qBAAqB;CACrB,UAAU;CACV,aAAa;AACd;AAEA;CACC,sDAAsD;CACtD,6BAA6B;CAC7B,qBAAqB;CACrB,sDAAsD;CACtD,6DAAqD;SAArD,qDAAqD;AACtD;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,iBAAiB;CACjB,cAAc;AACf;AAEA;CACC,oBAAc;KAAd,cAAc;AACf;AAEA;CACC;EACC,cAAc;CACf;;CAEA;EACC,2EAA2E;EAC3E,oBAAoB;CACrB;;CAEA;EACC,aAAa,EAAE,2CAA2C;CAC3D;AACD","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../utils.css';\n@import '../../helpers.css';\n\n.bookItPanel {\n\tfont-size: 16px;\n\tpadding: 5px;\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n.textGray {\n\tfont-size: 14px;\n}\n\n.checkInDate {\n\tfont-size: 14px;\n}\n\n.pullLeft {\n\tfloat: left;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.h3 {\n\tfont-size: 20px;\n\tmargin: 0;\n}\n\n.bookItDetails {\n\tfont-size: 16px;\n}\n\n.textArea {\n\theight: 110px !important;\n\tborder-radius: 6px;\n\tmargin-top: 20px;\n\tborder-color: var(--primary-border);\n}\n\n\n.houseRules {\n\tpadding-bottom: 20px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.houseRules:last-child {\n\tpadding-bottom: 0;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.paymentHeader {\n\tpadding: 5px;\n\tfont-size: 16px;\n}\n\n.textLight {\n\tcolor: var(--secondary-foreground);\n\tmargin-top: 15px;\n\tfont-size: 12px;\n\tdisplay: block;\n}\n\n.countryName {\n\tmargin: 0px 0px 8px;\n}\n\n.selectContainer {\n\tfont-size: 19px;\n\tline-height: 24px;\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tmax-width: 320px;\n}\n\n.formControlSelect {\n\tpadding: 8px 10px !important;\n\twidth: 100%;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tappearance: none;\n\tmax-width: 250px;\n}\n\n.colCenter {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 15px;\n}\n\n.backgroundCover {\n\tbackground-size: cover;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder-radius: 6px;\n}\n\n.bannerImage {\n\tpadding-top: 60%;\n\tposition: relative;\n}\n\n.profileAvatarSection {\n\tposition: relative;\n\ttext-align: center;\n\tmargin: 0 auto;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 2px solid var(--primary-border);\n}\n\n.profileAvatar {\n\theight: 60px;\n\twidth: 60px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tborder-bottom-left-radius: 4px !important;\n\tborder-bottom-right-radius: 4px !important;\n}\n\n.textMuted {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 16px;\n}\n\n.textLarge {\n\tfont-size: 24px;\n\tline-height: 30px;\n}\n\n.listStyle {\n\tmargin: 3px 0;\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.tableText {\n\tfont-weight: normal;\n}\n\n.totalText {\n\tborder: 0;\n\tpadding: 0;\n\twidth: 100%;\n\tbackground: transparent;\n\ttext-align: start;\n\tcursor: default;\n\tpointer-events: none;\n\tfont-size: 24px;\n\tline-height: 30px;\n}\n\na {\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: none;\n}\n\na:hover {\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n}\n\n.horizondalLine {\n\tmargin: 15px 0;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n.avatarWidth {\n\twidth: 43%;\n\ttext-align: center;\n\tpadding-right: 15px;\n}\n\n.contentWidth {\n\twidth: 57%\n}\n\n.positionSticky {\n\tposition: sticky !important;\n\ttop: 20px;\n}\n\n.secondSection {\n\tpadding: 20px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tmargin-bottom: 20px;\n}\n\n.propertyText {\n\tfont-size: 18px;\n\tline-height: 24px;\n}\n\n.listItem {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n}\n\n.postionRelative {\n\tposition: relative;\n}\n\n.arrrowIcon {\n\tmax-width: 24px;\n}\n\n.policyColor {\n\tcolor: var(--primary-link-foreground) !important;\n\ttext-decoration: none !important;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.textEllipsis {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.avatarImage {\n\twidth: 100%;\n\tmax-width: 63px;\n\tborder-radius: 50%;\n\theight: 63px;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n}\n\n.avatarSection {\n\twidth: 12%;\n\tpadding-right: 12px;\n}\n\n.messageSection {\n\tfont-size: 18px;\n}\n\n.vtrTop {\n\tvertical-align: top;\n}\n\n.itemWidth {\n\tpadding-left: 9px;\n}\n\n.aboutNoMargin {\n\tmargin-top: 0;\n\tpadding-top: 0\n}\n\n.aboutPaymentDesc {\n\tmargin: 15px 0 25px;\n\tfont-size: 16px;\n}\n\n.paymentPadding {\n\tpadding-left: 8px;\n}\n\n.cancelBtn {\n\tdisplay: flex;\n\tmargin-left: 25px;\n}\n\n.cancelLinkText {\n\tmargin-left: 12px;\n\tpadding: 8px 27px;\n\tcolor: var(--primary-link-foreground);\n\tfont-size: 14px;\n\tcursor: pointer;\n}\n\n.cancelLinkText:hover,\n.cancelLinkText:focus,\n.cancelLinkText:active,\n.cancelLinkText:active:hover,\n.cancelLinkText:active:focus {\n\tcolor: var(--primary-link-foreground);\n}\n\n.specialPriceText {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.faqImage {\n\twidth: 100%;\n\tmax-width: 19px;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n}\n\n.fullWidth {\n\twidth: 100%;\n}\n\n.pullRight {\n\tfloat: right !important;\n}\n\n.cardInput {\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 6px 12px;\n\tfont-size: 14px;\n\tline-height: 1.42857143;\n\tbackground-color: var(--primary-input-bg);\n\tbackground-image: none;\n\tborder-radius: 4px;\n\theight: 40px;\n\tborder: 1px solid var(--primary-border);\n\tmargin-bottom: 15px;\n\tfont-weight: 400;\n}\n\n.cardInput:focus {\n\tborder-color: var(--primary-border) !important;\n\tbox-shadow: none !important;\n}\n\n.cardNumber {\n\tpadding: 10px 0;\n\tborder: 0;\n\tborder-bottom: 1px solid var(--primary-border);\n\tborder-radius: 0;\n}\n\n.cardNumberSection {\n\tposition: relative;\n}\n\n.cardNumberSectionOne {\n\ttext-align: left;\n}\n\n.cardNumberSectionOne::after {\n\tcontent: '';\n\tbackground-image: url('../../../../public/SiteIcons/credit-card.svg');\n\tposition: absolute;\n\ttop: 8px;\n\tbottom: 0px;\n\tbackground-repeat: no-repeat;\n\twidth: 100%;\n\tbackground-position: 100%;\n\tmax-width: 25px;\n\tright: 0;\n\tz-index: 0;\n}\n\n.cardNumberSectionTwo::after {\n\tcontent: '';\n\tbackground-image: url('../../../../public/SiteIcons/calendar.svg');\n\tposition: absolute;\n\ttop: 0px;\n\tbottom: 0px;\n\tbackground-repeat: no-repeat;\n\twidth: 100%;\n\tbackground-position: 100%;\n\tmax-width: 25px;\n\tright: 0;\n\tz-index: 0;\n}\n\n.cardNumberSectionThree::after {\n\tcontent: '';\n\tbackground-image: url('../../../../public/SiteIcons/padlock.svg');\n\tposition: absolute;\n\ttop: 0px;\n\tbottom: 0px;\n\tbackground-repeat: no-repeat;\n\twidth: 100%;\n\tbackground-position: 100%;\n\tmax-width: 25px;\n\tright: 0;\n\tz-index: 0;\n}\n\n.cardNumberSectionFour {\n\tbackground-image: url('../../../../public/SiteIcons/location.svg');\n\tbackground-repeat: no-repeat;\n\tbackground-position: 100%;\n}\n\n.noBoxShadow {\n\tbox-shadow: none !important;\n\toutline: none !important;\n}\n\n.labelText {\n\tmargin-bottom: 0 !important;\n\tfont-size: 14px !important;\n\tfont-weight: 600;\n}\n\n.stripeImg {\n\tmax-width: 170px;\n}\n\n.cardSection {\n\tpadding: 25px !important;\n\tmargin: 20px 15px 0;\n\tborder-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.titleText {\n\tfont-size: 26px;\n\tfont-weight: 600;\n\tmargin-bottom: 30px;\n}\n\n.dateTitle {\n\tfont-size: 18px;\n\tmargin-bottom: 7px;\n}\n\n.showDate {\n\tcolor: var(--secondary-foreground);\n}\n\n.flex {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.disabledLink {\n\tpointer-events: none;\n\tcursor: default;\n\topacity: 0.6;\n}\n\n.editCss {\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-size: 16px;\n\ttext-decoration: underline;\n}\n\n.editIcon {\n\tposition: relative;\n\ttop: -2px;\n\tdisplay: inline-block;\n\tmargin-left: 3px;\n}\n\n.marginTop {\n\tmargin-top: 25px;\n}\n\n.commonBorder {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.grid {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tcolor: var(--secondary-foreground);\n\tpadding: 0 20px 10px 20px;\n\tfont-size: 16px;\n\tgap: 10px;\n}\n\n.totalValue {\n\tborder-top: 1px solid var(--primary-border);\n\tpadding: 20px;\n\tcolor: var(--primary-foreground);\n\tfont-size: 18px;\n\tmargin-top: 10px;\n\tfont-weight: 600;\n}\n\n.policyCss {\n\ttext-align: center;\n\tmargin: 30px 0;\n}\n\n.noPaddingLeft {\n\tpadding-left: 0;\n}\n\n.noPaddingRight {\n\tpadding-right: 0;\n}\n\n.noPadding {\n\tpadding: 0;\n}\n\n.payPalTop {\n\tmargin-top: 20px;\n}\n\n.footerBtns {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 25px 0 40px;\n\tpadding-top: 25px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n}\n\n.pricingTitle {\n\tfont-size: 18px;\n\tmargin-bottom: 15px;\n\tpadding-left: 20px;\n}\n\n.reviewFlex {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.dotsCss {\n\tmargin: 0 8px;\n}\n\n.starCss {\n\tposition: relative;\n\ttop: 4px;\n\tmargin-right: 2px;\n}\n\n.radioTextSection {\n\tfont-weight: 400;\n}\n\n.hostFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tcolumn-gap: 15px;\n}\n\n.bold {\n\tfont-weight: 600;\n}\n\n.loaderFlex {\n\tdisplay: flex;\n\tcolumn-gap: 3px;\n\talign-items: center;\n}\n\n.discountText {\n\tcolor: var(--discountAndSpecial-color);\n}\n\n.cancelBtnLineHeight {\n\tline-height: 23px;\n}\n\n.houseRulesTick {\n\tcolor: var(--secondary-bg);\n}\n\n@media screen and (max-width: 1200px) {\n\t.colCenter {\n\t\tmargin: 0 15px;\n\t}\n}\n\n@media (max-width: 1200px) and (min-width: 992px) {\n\t.positionSticky {\n\t\ttop: 100px;\n\t}\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n\t.avatarWidth {\n\t\twidth: 40%;\n\t}\n\n\t.contentWidth {\n\t\twidth: 60%;\n\t}\n\n\t.propertyText {\n\t\tline-height: 24px;\n\t}\n}\n\n@media screen and (max-width: 1199px) {\n\t.listItem {\n\t\tfont-size: 14px;\n\t}\n\n\t.bookItPanel {\n\t\tpadding: 50px 15px 0;\n\t}\n}\n\n@media (max-width: 991px) and (min-width: 640px) {\n\t.avatarWidth {\n\t\twidth: 40%;\n\t\ttext-align: center;\n\t\tpadding-right: 6px;\n\t}\n\n\t.contentWidth {\n\t\twidth: 60%;\n\t}\n\n\t.propertyText {\n\t\tline-height: 24px;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.flexwrap {\n\t\tflex-wrap: wrap;\n\t}\n\n\t.paddingRight15 {\n\t\tpadding-right: 15px !important;\n\t}\n\n\t.paddingLeft15 {\n\t\tpadding-left: 15px !important;\n\t}\n\n\t.expireSection {\n\t\tmargin-bottom: 12px;\n\t\tpadding-top: 0px !important;\n\t}\n\n\t.cardSection {\n\t\tmargin: 20px 0px 0px;\n\t}\n\n\t.responsivecardSection {\n\t\tpadding: 0 15px !important;\n\t}\n\n\t.noMobileLeftPadding {\n\t\tpadding-left: 0;\n\t}\n\n\t.noMobileRightPadding {\n\t\tpadding-right: 0;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.smPadding {\n\t\tpadding: 0;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.avatarWidth {\n\t\twidth: 40%;\n\t}\n\n\t.contentWidth {\n\t\twidth: 60%;\n\t}\n\n\t.propertyText {\n\t\tfont-size: 16px;\n\t\tline-height: 18px;\n\t}\n\n\t.bannerImage {\n\t\tpadding-top: 70%;\n\t}\n\n\t.profileAvatar {\n\t\twidth: 50px;\n\t\theight: 50px;\n\t}\n\n\t.avatarSection {\n\t\twidth: 24%;\n\t\tpadding-right: 6px;\n\t}\n\n\t.vtrTopSm {\n\t\tvertical-align: top;\n\t}\n}\n\n@media screen and (max-width:991px) {\n\t.positionSticky {\n\t\tposition: inherit !important;\n\t\ttop: auto;\n\t}\n}\n\n/* Sticky Footer Styles */\n.stickyFooter {\n\tposition: fixed !important;\n\tbottom: 0px !important;\n\tleft: 0px !important;\n\tright: 0px !important;\n\tz-index: 4;\n\tdisplay: none;\n}\n\n.stickyFooterContainer {\n\tbackground-color: var(--background-primary) !important;\n\tpadding: 16px 24px !important;\n\tz-index: 5 !important;\n\tborder-top: 1px solid var(--primary-border) !important;\n\tbox-shadow: 0px 0px 4px 1px var(--primary-box-shadow);\n}\n\n.stickyFooterContent {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmax-width: 1200px;\n\tmargin: 0 auto;\n}\n\n.stickyFooterButton {\n\tflex-shrink: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.stickyFooter {\n\t\tdisplay: block;\n\t}\n\n\t.bookItPanel {\n\t\t/* padding-bottom: 100px; Prevent content from being hidden behind footer */\n\t\tpadding-bottom: 15px;\n\t}\n\n\t.footerBtns {\n\t\tdisplay: none; /* Hide original footer buttons on mobile */\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `Payment-errorMessage-a9k0q`,
	"space1": `Payment-space1-owPII`,
	"space2": `Payment-space2-Sgko7`,
	"space3": `Payment-space3-flr17`,
	"space4": `Payment-space4-VxsGM`,
	"space5": `Payment-space5-FrWVq`,
	"space6": `Payment-space6-gdr5R`,
	"space7": `Payment-space7-Jvb71`,
	"spaceTop8": `Payment-spaceTop8-SV3S8`,
	"spaceTop1": `Payment-spaceTop1-HZN0O`,
	"spaceTop2": `Payment-spaceTop2-otjhl`,
	"spaceTop3": `Payment-spaceTop3-dmDNJ`,
	"spaceTop4": `Payment-spaceTop4-NzjUV`,
	"spaceTop5": `Payment-spaceTop5-SNydT`,
	"spaceTop6": `Payment-spaceTop6-Xb20G`,
	"spaceTop7": `Payment-spaceTop7-BA9Cg`,
	"noMargin": `Payment-noMargin-PoQFy`,
	"padding1": `Payment-padding1-g5knV`,
	"padding2": `Payment-padding2-RIkR3`,
	"padding3": `Payment-padding3-AsmKO`,
	"padding4": `Payment-padding4-GogI9`,
	"padding5": `Payment-padding5-PJlZz`,
	"padding6": `Payment-padding6-MSg70`,
	"padding7": `Payment-padding7-j2Ir3`,
	"paddingTop1": `Payment-paddingTop1-Sof1z`,
	"paddingTop2": `Payment-paddingTop2-xZG4n`,
	"paddingTop3": `Payment-paddingTop3-vq92u`,
	"paddingTop4": `Payment-paddingTop4-PRqXc`,
	"paddingTop5": `Payment-paddingTop5-HNNKn`,
	"paddingTop6": `Payment-paddingTop6-McxMl`,
	"paddingTop7": `Payment-paddingTop7-qHheT`,
	"noPadding": `Payment-noPadding-vkxVH`,
	"textBold": `Payment-textBold-QvDeZ`,
	"textBolder": `Payment-textBolder-EEBBs`,
	"textNormal": `Payment-textNormal-hx7W3`,
	"spaceBottom20": `Payment-spaceBottom20-UVXF2`,
	"spaceBottom10": `Payment-spaceBottom10-RzJeM`,
	"marginNone": `Payment-marginNone-dkVQN`,
	"spaceBottom15": `Payment-spaceBottom15-rOzM9`,
	"marginTopNone": `Payment-marginTopNone-kCRk_`,
	"spaceTop11": `Payment-spaceTop11-Ag1qo`,
	"spaceTop21": `Payment-spaceTop21-wllkI`,
	"spaceTop20": `Payment-spaceTop20-__3FB`,
	"spaceTop10": `Payment-spaceTop10-snOaU`,
	"textDarkBlue": `Payment-textDarkBlue-k9oRc`,
	"textLightBlue": `Payment-textLightBlue-DDoiv`,
	"textLightSandleGreen": `Payment-textLightSandleGreen-alkcl`,
	"textLightBrown": `Payment-textLightBrown-u5mto`,
	"textMediumMaroon": `Payment-textMediumMaroon-d7mqQ`,
	"textBrown": `Payment-textBrown-Zpc75`,
	"textMaroon": `Payment-textMaroon-S_zQF`,
	"textDarkBrown": `Payment-textDarkBrown-ErcVZ`,
	"textMediumBrown": `Payment-textMediumBrown-x5OlM`,
	"textSkyBlue": `Payment-textSkyBlue-AOrIy`,
	"textGray": `Payment-textGray-QthXf`,
	"bookItPanel": `Payment-bookItPanel-VtfJ0`,
	"textLeft": `Payment-textLeft-UNohi`,
	"textRight": `Payment-textRight-aPJ4d`,
	"checkInDate": `Payment-checkInDate-hJhA2`,
	"pullLeft": `Payment-pullLeft-Ei4PU`,
	"pullRight": `Payment-pullRight-f1rbc`,
	"h3": `Payment-h3-UvgXU`,
	"bookItDetails": `Payment-bookItDetails-DPUBO`,
	"textArea": `Payment-textArea-ckvJu`,
	"houseRules": `Payment-houseRules-cw7Vy`,
	"textCenter": `Payment-textCenter-Ahj_F`,
	"paymentHeader": `Payment-paymentHeader-NMqkf`,
	"textLight": `Payment-textLight-pVMcG`,
	"countryName": `Payment-countryName-x4IYl`,
	"selectContainer": `Payment-selectContainer-K27Hk`,
	"formControlSelect": `Payment-formControlSelect-V6hDt`,
	"colCenter": `Payment-colCenter-g5vCG`,
	"backgroundCover": `Payment-backgroundCover-AVpTS`,
	"bannerImage": `Payment-bannerImage-ZbrHv`,
	"profileAvatarSection": `Payment-profileAvatarSection-xPkLK`,
	"profileAvatarLink": `Payment-profileAvatarLink-nIYcT`,
	"profileAvatar": `Payment-profileAvatar-pjsje`,
	"panelHeader": `Payment-panelHeader-Ly5AA`,
	"textMuted": `Payment-textMuted-xm7br`,
	"textLarge": `Payment-textLarge-biOpI`,
	"listStyle": `Payment-listStyle-L3kfa`,
	"noBorder": `Payment-noBorder-Gxanp`,
	"tableText": `Payment-tableText-H_MPh`,
	"totalText": `Payment-totalText-edjy6`,
	"horizondalLine": `Payment-horizondalLine-K82vJ`,
	"displayInline": `Payment-displayInline-eiquD`,
	"avatarWidth": `Payment-avatarWidth-gQIgL`,
	"contentWidth": `Payment-contentWidth-wcyAg`,
	"positionSticky": `Payment-positionSticky-K2qPT`,
	"secondSection": `Payment-secondSection-SNdEs`,
	"propertyText": `Payment-propertyText-it5bD`,
	"listItem": `Payment-listItem-SR0fd`,
	"postionRelative": `Payment-postionRelative-ukkUB`,
	"arrrowIcon": `Payment-arrrowIcon-AfOki`,
	"policyColor": `Payment-policyColor-cQXR7`,
	"vtrMiddle": `Payment-vtrMiddle-ELBTO`,
	"textEllipsis": `Payment-textEllipsis-TAL2d`,
	"avatarImage": `Payment-avatarImage-tzIeo`,
	"displayTable": `Payment-displayTable-OjhvB`,
	"displayTableRow": `Payment-displayTableRow-Bi5zI`,
	"displayTableCell": `Payment-displayTableCell-Qlgq5`,
	"avatarSection": `Payment-avatarSection-RvetV`,
	"messageSection": `Payment-messageSection-qne5R`,
	"vtrTop": `Payment-vtrTop-uPtZQ`,
	"itemWidth": `Payment-itemWidth-HCzgr`,
	"aboutNoMargin": `Payment-aboutNoMargin-snra1`,
	"aboutPaymentDesc": `Payment-aboutPaymentDesc-AzRff`,
	"paymentPadding": `Payment-paymentPadding-IzpKe`,
	"cancelBtn": `Payment-cancelBtn-wDQ57`,
	"cancelLinkText": `Payment-cancelLinkText-OVnSx`,
	"specialPriceText": `Payment-specialPriceText-MWQ1B`,
	"faqImage": `Payment-faqImage-DqGn9`,
	"fullWidth": `Payment-fullWidth-uEg2R`,
	"cardInput": `Payment-cardInput-t3E6C`,
	"cardNumber": `Payment-cardNumber-t9H_B`,
	"cardNumberSection": `Payment-cardNumberSection-giKMr`,
	"cardNumberSectionOne": `Payment-cardNumberSectionOne-kHjfG`,
	"cardNumberSectionTwo": `Payment-cardNumberSectionTwo-gQtMv`,
	"cardNumberSectionThree": `Payment-cardNumberSectionThree-sxTXs`,
	"cardNumberSectionFour": `Payment-cardNumberSectionFour-nI1_V`,
	"noBoxShadow": `Payment-noBoxShadow-yYJ5w`,
	"labelText": `Payment-labelText-UfIMF`,
	"stripeImg": `Payment-stripeImg-eLAcU`,
	"cardSection": `Payment-cardSection-cCIm5`,
	"titleText": `Payment-titleText-SjjCe`,
	"dateTitle": `Payment-dateTitle-unvZW`,
	"showDate": `Payment-showDate-Akglr`,
	"flex": `Payment-flex-gooqR`,
	"disabledLink": `Payment-disabledLink-OOWrp`,
	"editCss": `Payment-editCss-wSUaE`,
	"editIcon": `Payment-editIcon-kHIlQ`,
	"marginTop": `Payment-marginTop-kfjpy`,
	"commonBorder": `Payment-commonBorder-_kIjn`,
	"grid": `Payment-grid-Jjzna`,
	"totalValue": `Payment-totalValue-AWHev`,
	"policyCss": `Payment-policyCss-w34fX`,
	"noPaddingLeft": `Payment-noPaddingLeft-t11fG`,
	"noPaddingRight": `Payment-noPaddingRight-vI2Nj`,
	"payPalTop": `Payment-payPalTop-GvWni`,
	"footerBtns": `Payment-footerBtns-O9PWA`,
	"pricingTitle": `Payment-pricingTitle-n6S4e`,
	"reviewFlex": `Payment-reviewFlex-jsF0a`,
	"dotsCss": `Payment-dotsCss-gIQEY`,
	"starCss": `Payment-starCss-RDMmw`,
	"radioTextSection": `Payment-radioTextSection-jZ2MU`,
	"hostFlex": `Payment-hostFlex-vgDv2`,
	"bold": `Payment-bold-uHhdv`,
	"loaderFlex": `Payment-loaderFlex-_T8Ps`,
	"discountText": `Payment-discountText-_Sava`,
	"cancelBtnLineHeight": `Payment-cancelBtnLineHeight-rkiPX`,
	"houseRulesTick": `Payment-houseRulesTick-NG4dD`,
	"flexwrap": `Payment-flexwrap-MOoqz`,
	"paddingRight15": `Payment-paddingRight15-QYVIA`,
	"paddingLeft15": `Payment-paddingLeft15-DolWh`,
	"expireSection": `Payment-expireSection-MFctV`,
	"responsivecardSection": `Payment-responsivecardSection-_ioDt`,
	"noMobileLeftPadding": `Payment-noMobileLeftPadding-Hccck`,
	"noMobileRightPadding": `Payment-noMobileRightPadding-AvTt2`,
	"smPadding": `Payment-smPadding-Lbx2V`,
	"vtrTopSm": `Payment-vtrTopSm-TRhXo`,
	"stickyFooter": `Payment-stickyFooter-XEN08`,
	"stickyFooterContainer": `Payment-stickyFooterContainer-EqApM`,
	"stickyFooterContent": `Payment-stickyFooterContent-iiCPk`,
	"stickyFooterButton": `Payment-stickyFooterButton-AkfIs`
};
module.exports = ___CSS_LOADER_EXPORT___;
